<template>
  <div class="logs-page">
      <logs-table ref="tableRef"></logs-table>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { log } from '../../utils/DebugLogger';
import LogsTable from './LogsTable.vue';

interface LogsTableInstance {
  loadData?: () => void;
}

const { t } = useI18n();

const tableRef = ref<LogsTableInstance | null>(null);

onMounted(() => {
  log('LogsPage', 'mounted', 'Component mounted');
});
</script>

<style scoped>
.logs-page {
  padding: 0;
}
</style>
